module.exports = __webpack_public_path__ + "img/unaffiliated.0a852ddb.svg";